import { useAudienceInterestEligible } from './audienceInterestService'

export { useAudienceInterestEligible }
